module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_prl_r1.htm",
      "id": "prl"
    }
  }, [_vm._v("PROLOGUE: SANTIAGO DE CUBA")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c01_r1.htm",
      "id": "c01"
    }
  }, [_vm._v("1 NEW YORK CITY")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c02_r1.htm",
      "id": "c02"
    }
  }, [_vm._v("2 HAVANA, CUBA")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c03_r1.htm",
      "id": "c03"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c04_r1.htm",
      "id": "c04"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c05_r1.htm",
      "id": "c05"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c06_r1.htm",
      "id": "c06"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c07_r1.htm",
      "id": "c07"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c08_r1.htm",
      "id": "c08"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c09_r1.htm",
      "id": "c09"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c10_r1.htm",
      "id": "c10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c11_r1.htm",
      "id": "c11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c12_r1.htm",
      "id": "c12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c13_r1.htm",
      "id": "c13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c14_r1.htm",
      "id": "c14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c15_r1.htm",
      "id": "c15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c16_r1.htm",
      "id": "c16"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c17_r1.htm",
      "id": "c17"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c18_r1.htm",
      "id": "c18"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c19_r1.htm",
      "id": "c19"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c20_r1.htm",
      "id": "c20"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c21_r1.htm",
      "id": "c21"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c22_r1.htm",
      "id": "c22"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c23_r1.htm",
      "id": "c23"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c24_r1.htm",
      "id": "c24"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_c25_r1.htm",
      "id": "c25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_ack_r1.htm",
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_col1_r1.htm",
      "id": "col1"
    }
  }, [_vm._v("Books by William Heffernan")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_bm1_r1.htm",
      "id": "bm1"
    }
  }, [_vm._v("Please turn the page for an early look at")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_bm2_r1.htm",
      "id": "bm2"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/About_the_Author.htm",
      "id": "abt"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_fm1_r1.htm",
      "id": "fm1"
    }
  }, [_vm._v("Praise for Edgar Award-winner: WILLIAM HEFFERNAN: and: RED ANGEL")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062028976_epub_cop_r1.htm",
      "id": "cop"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/About_the_Publisher.htm",
      "id": "pub"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dac67b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062028976_epub_toc_r1.vue
// module id = 66
// module chunks = 0